import { render, staticRenderFns } from "./CoOp.vue?vue&type=template&id=d0536722&lang=pug&"
import script from "./CoOp.vue?vue&type=script&lang=ts&"
export * from "./CoOp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports